import script from "./RegistrationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationForm.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationForm.vue?vue&type=style&index=0&id=0a17f517&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a17f517"]])

export default __exports__